import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetCaseDocThemes = ({ caseId }: { caseId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<string[]>(
    [QueryEntity.DocThemes, { caseId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/doc-themes`, fetchConfigGET).then((res) => res.json());
    },
    { enabled: Boolean(caseId), staleTime: Infinity, refetchOnWindowFocus: false },
  );
};
